import { render, staticRenderFns } from "./collection-order-view.vue?vue&type=template&id=5afc1824&scoped=true"
import script from "./collection-order-view.vue?vue&type=script&lang=ts"
export * from "./collection-order-view.vue?vue&type=script&lang=ts"
import style0 from "./collection-order-view.vue?vue&type=style&index=0&id=5afc1824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afc1824",
  null
  
)

export default component.exports